module.exports = __webpack_public_path__ + "img/20200609_114030.70ccc7c9.jpg";